/* eslint no-param-reassign: ["error", { "props": false }] */

import Vue from 'vue';
import Vuex from 'vuex';
import api from '../../common/config/apiAxiosInstance';

Vue.use(Vuex);

const getDefaultState = () => ({
  items: [],
  count: 0,
  totalAmount: 0,
  orderPath: '#',
});

// initial state
const storeState = getDefaultState();

// mutations
const storeMutations = {
  setCartData(state, data) {
    Object.assign(state, {
      items: data.items,
      totalAmount: data.total_amount,
      count: data.count,
      orderPath: data.order_path,
    });
  },
};

// actions
const storeActions = {
  removeFromCart({ commit }, { id, quantity }) {
    api.delete(`library_orders/${id}?quantity=${quantity}`).then((response) => {
      commit('setCartData', response.data);
    });
  },
  getCartContent({ commit }) {
    api
      .get('library_orders.json')
      .then((response) => {
        commit('setCartData', response.data);
      });
  },
};

// getters
const storeGetters = {
  orderPath(state) {
    return state.orderPath;
  },
  totalAmount(state) {
    return state.totalAmount;
  },
  cartItems(state) {
    return state.items;
  },
  itemsCount(state) {
    return state.count;
  },
};

// export
const store = new Vuex.Store({
  state: storeState,
  actions: storeActions,
  mutations: storeMutations,
  getters: storeGetters,
});

export default store;
